import { useNavigate, useSearch } from '@tanstack/react-router';
import { Button, Divider, Typography } from '@/primer/components';
import { PageLayout } from '@/components/layout';
import { SocialAuthButton } from '@/components/ui';

export function InviteAuthMethod() {
  const { token } = useSearch({ from: '/_public/invite' });
  const navigate = useNavigate();

  const tokenValue = typeof token === 'string' ? token : '';
  const hasToken = tokenValue.trim().length > 0;

  return (
    <PageLayout className="py-8" gridProps={{ className: 'px-5' }}>
      <div className="flex flex-col gap-6">
        <Button
          variant="primary"
          size="large"
          fullWidth
          disabled={!hasToken}
          onClick={() => void navigate({ to: '/invite/email', search: { token: tokenValue } })}
          data-testid="invite-continue-with-email-button"
        >
          Continue with email
        </Button>

        {/* Divider is a sealed component — flex wrappers stretch each rule on either side of "Or". */}
        <div className="flex items-center gap-3">
          <div className="flex-1">
            <Divider />
          </div>
          <Typography variant="body" size="medium" color="bodylighter" as="span">
            Or
          </Typography>
          <div className="flex-1">
            <Divider />
          </div>
        </div>

        <div className="flex flex-col gap-4">
          {/* TODO: wire social buttons once sign-in behaviour is defined. */}
          <SocialAuthButton provider="Facebook" data-testid="invite-facebook-button" />
          <SocialAuthButton provider="Google" data-testid="invite-google-button" />
          <SocialAuthButton provider="Apple" data-testid="invite-apple-button" />
        </div>
      </div>
    </PageLayout>
  );
}

export default InviteAuthMethod;
